(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (document.documentElement && document.documentElement.clientWidth)
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
        else if (document.documentElement && document.documentElement.clientHeight)
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }

    //googleMaps
    window.initMaps = function() {
      if ( $('.map').length ) {
        initializeMap('map');
    }
};

function initializeMap(container) {
    var mapContainer = document.getElementById(container);
    var lat = $(mapContainer).data('lat');
    var lng = $(mapContainer).data('lng');
    var map;
    var markerPosition = { lat: lat, lng: lng };

           //Set the options
    var mapOptions = {
        zoom: 14,
        center: new google.maps.LatLng(lat, lng),
        disableDefaultUI: false,
        backgroundColor: '#ffffff',
        panControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        mapTypeControl: false,
    };

    map = new google.maps.Map(mapContainer, mapOptions);
    const marker = new google.maps.Marker({
        position: markerPosition,
        map: map,
    });

    google.maps.event.addDomListener(window, 'load', mapOptions);
}


    //------Animate On Scroll
$win.on('load', function(event) {
    $('.js-animated')
    .attr({
        "data-aos" : "fade-up",
    });

    setTimeout(function(){
        AOS.init({
            duration: 1500,
        });
    }, 120);
    $('.js-popup').magnificPopup({
        type: 'inline',
    });
    
});

    //-----Hero Slider
const swiper = new Swiper('.swiper', {
    loop: false,
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})


    //------OnClick Handlers

    //Nav Mobile
$('.header').on('click', '.nav-btn', function(event) {
    event.preventDefault();

    $('.header').toggleClass('is-open');
    $('body').toggleClass('nav-open');
});


$win.on('load', function(event) {
    $('.js-has-dropdown > a').each(function(){
        $(this).one('click', function(e){
            if($win.width() <= 1023) {
                e.preventDefault();

                const $this = $(this);
                var $dropdown = $this.siblings("ul");

                $dropdown.toggleClass('dropdown-open');
            }
        })
    })
});

    //Show More/Less
$('.js-show-content').on('click', function(event) {
    event.preventDefault();

    const $this = $(this);

    $this.toggleClass('is-active');
    $this.siblings('.js-content-hidden').toggleClass('content-expanded'); 

    if($this.hasClass('is-active')){
        $this.text('Read less');
    } else {
        $this.text('Read more');
    }
});


    //Tabs
$('.tabs__nav').on('click', 'a', function(event) {
    event.preventDefault();

    const $this = $(this);
    const $target = $(`${$this.attr("href")}`);

    $this.parent().addClass('is-current');
    $this.parent().siblings().removeClass('is-current');

    $target.siblings().removeClass('is-current');
    $target.addClass('is-current');

    AOS.refresh();
});


    //Magnific Popup 
$(document).ready(function($) {

    $('a[href="#book-a-table"]').each(function(){
        $(this).addClass('js-popup');
    });
    $('a[href="#book-a-room"]').each(function(){
        $(this).addClass('js-popup');
    });
});   


    //Intro Screen
function loadWindow() {
    setTimeout(function() {
        $('.js-logo').addClass('is-visible');
    }, 500);

    setTimeout(function() {
        $('.js-logo-secondary').addClass('is-visible');
    }, 1500);

    setTimeout(function() {
        $('.section-intro').removeClass('is-visible');
        $('.js-logo-secondary').removeClass('is-visible');
    }, 3000);

    setTimeout(function() {
        $('.js-logo').addClass('is-light');
        $('body').removeClass('is-not-scrollable');
    }, 3100);  

    if($win.width() <= 1023) {
        setTimeout(function() {
            $('.js-logo').addClass('is-attached-top');
        }, 3050);
    }
}

$win.on('load', function(event) {
    loadWindow();
});

$win.one('scroll', function(event){
    $('.js-logo').addClass('is-attached-top');
})

history.scrollRestoration = "manual";

$win.on('load', function(e) {
    let searchParams = new URLSearchParams(window.location.search)
    if ( searchParams.has('id') ) {
        let href = '#' + searchParams.get('id')
        if ( href.indexOf('#') !== -1 ) {
            var hash = href.substring(href.indexOf('#'));
        }
        $('html, body').animate({
            scrollTop: ( $(href).offset().top - $('.header').outerHeight() )
        }, 800);
    }
});
})(jQuery, window, document);